import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DefaultLayout } from '@gsa/afp-component-library';
import { useCurrentUser, useNavigationMenu } from '@gsa/afp-shared-ui-utils';
import GlobalErrorMessages from '../pages/error/global-error-messages';
import { clearUserContext, setUserContext } from './datadog-trace-utils';

const Layout = ({ children }) => {
  const { currentUser, isLoggedIn } = useCurrentUser();

  /* To check for global messages in a generic way
   const { data: globalMessages } = useQuery(GetGlobalMessagesCacheQuery, {
    fetchPolicy: "cache-only",   // Used for first execution
  });
  const [globalMessages, setGlobalMessages] = useState(null);
  const querySubscription = dataStore
    .watchQuery({
      query: GetGlobalMessagesCacheQuery,
      fetchPolicy: 'cache-only',
    })
    .subscribe({
      next: ({ data }) => {
        console.log('globalMessages sub', globalMessages);
        setGlobalMessages(data.messages);
      },
    }); */

  const menu = useNavigationMenu();

  useEffect(() => {
    if (isLoggedIn && currentUser) {
      setUserContext({
        id: currentUser.id,
        roles: currentUser.roles,
      });
    } else if (!isLoggedIn) {
      // Clear user context when not logged in
      clearUserContext();
    }
  }, [currentUser, isLoggedIn]);

  return (
    <DefaultLayout currentUser={isLoggedIn && currentUser} menu={menu}>
      <GlobalErrorMessages />
      {children}
    </DefaultLayout>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
